// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userMenue[data-v-698a6545]{position:absolute;width:90%;background:#fff;filter:drop-shadow(0 0 10px rgba(0,0,0,.2));z-index:99}.material-design-icon[data-v-698a6545]{height:25px;width:25px}.material-design-icon>.material-design-icon__svg[data-v-698a6545]{fill:#000;height:25px;width:25px}.md-list-item-icon[data-v-698a6545]{margin-right:10px}.md-list-item-text[data-v-698a6545]{font-size:14px}", ""]);
// Exports
module.exports = exports;
